import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { heroBadgesData } from '@/mocks/homeData';
import StoreChoiceModal from '@/components/feature/StoreChoiceModal';

export default function HeroSection() {
  const { t } = useTranslation();
  const [storeModalOpen, setStoreModalOpen] = useState(false);

  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20tennis%20court%20at%20sunset%20with%20golden%20light%20streaming%20across%20the%20green%20surface%2C%20stylized%20luxury%20aesthetic%2C%20warm%20golden%20hour%20tones%2C%20geometric%20court%20lines%20in%20white%2C%20soft%20atmospheric%20haze%2C%20elegant%20sports%20photography%20with%20dramatic%20lighting%2C%20no%20people%2C%20premium%20editorial%20style&width=1920&height=1080&seq=hero-tcd-2026&orientation=landscape"
          alt="Tennis Club de Douala — Court principal"
          className="w-full h-full object-cover object-top"
        />
        {/* Dark overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/55"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 text-center">
        <div className="max-w-4xl mx-auto">
          {/* Badges */}
          <div className="flex flex-wrap items-center justify-center gap-3 mb-8">
            {heroBadgesData.map((badge, idx) => (
              <span
                key={idx}
                className="px-4 py-1.5 text-xs md:text-sm font-medium tracking-wide uppercase rounded-full border border-accent-400/40 bg-accent-500/10 text-accent-200 backdrop-blur-sm whitespace-nowrap"
              >
                {badge}
              </span>
            ))}
          </div>

          {/* Title */}
          <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-6">
            {t('hero.title')}
            <br />
            <span className="text-accent-400 italic">{t('hero.titleHighlight')}</span>
          </h1>

          {/* Subtitle */}
          <p className="text-base md:text-lg text-background-50/80 font-light tracking-wide mb-10 max-w-2xl mx-auto">
            {t('hero.subtitle')}
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/contact"
              className="w-full sm:w-auto px-8 py-3.5 text-sm md:text-base font-semibold rounded-full bg-accent-500 text-background-50 hover:bg-accent-600 transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
            >
              {t('hero.ctaJoin')}
            </Link>
            <button
              onClick={() => setStoreModalOpen(true)}
              className="w-full sm:w-auto px-8 py-3.5 text-sm md:text-base font-semibold rounded-full border-2 border-background-50/40 text-background-50 hover:bg-background-50/10 hover:border-background-50/60 transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
            >
              {t('hero.ctaBook')}
            </button>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-xs tracking-widest uppercase text-background-50/60 font-medium">{t('hero.scrollDown')}</span>
        <i className="ri-arrow-down-line text-background-50/50 text-lg"></i>
      </div>

      {/* Decorative bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background-50 to-transparent z-[5]"></div>

      <StoreChoiceModal open={storeModalOpen} onClose={() => setStoreModalOpen(false)} />
    </section>
  );
}